import * as angular from 'angular';

import { SelectOption } from '@mode/shared/ui-angularjs';

class DefaultAccessRowController {
  private onSelect: ($args: { $option: SelectOption }) => void;
  private caption = '';

  static $inject = ['$rootScope'];

  constructor(private $rootScope) {}

  public handleDropdownInit($option: SelectOption): void {
    this.setCaption($option.labelCaption);
  }

  public handleDropdownSelection($option: SelectOption): void {
    this.setCaption($option.labelCaption);

    if (this.onSelect) {
      this.$rootScope.$applyAsync((): void => {
        this.onSelect({ $option });
      });
    }
  }

  private setCaption(caption: SelectOption['labelCaption']): void {
    this.$rootScope.$applyAsync((): void => {
      this.caption = caption;
    });
  }
}

export const DefaultAccessRowComponent: angular.IComponentOptions = {
  controller: DefaultAccessRowController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    selected: '@',
    inputId: '@',
    inputName: '@',
    onSelect: '&?',
  },
  template: `
    <div class="default-access-row-container">
      <capra-icon class="align-md-icon default-access-icon" icon="icon-building"></capra-icon>

      <label class="default-access-label" for="{{ ctrl.inputId }}">
        <span>Default</span
        >&nbsp;<span>Workspace</span
        >&nbsp;<span>access:</span>
      </label>

      <connection-permissions-default-access-dropdown
        input-id="{{ ctrl.inputId }}"
        input-name="{{ ctrl.inputName }}"
        selected="{{ ctrl.selected }}"
        on-init="ctrl.handleDropdownInit($option)"
        on-select="ctrl.handleDropdownSelection($option)"
      />

      <p class="default-access-description">
        {{ ctrl.caption }}
      </p>
    </div>
  `,
};
